import { RootState } from "../../rootReducer";

export const selectIsDownloadingBusinessUserCSV = (state: RootState) =>
  state.downloadBusinessUserCSV.loading;
export const downloadBusinessUserCSVErrorMessage = (state: RootState) =>
  state.downloadBusinessUserCSV.error;
export const downloadBusinessUserCSVResponse = (state: RootState) =>
  state.downloadBusinessUserCSV.downloadBusinessUserCSVResponse;
